import axios from "@/utils/axios";

enum Api {
  ALogin = "/user/login",
  code = "/api/open/sendCode",
  updatePerson = "/api/open/updatePhoto",
  queryStudent = "/wxapi/wechat/studentList",
  switchBind = "/wxapi/wechat/shiftBind",
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace Login {
  // 用户登录表单
  export interface LoginReqForm {
    username: string;
    password: string;
  }
  // 登录成功后返回的token
  export interface LoginResData {
    token: string;
  }
  export interface SendCodeForm {
    cid?: string | number;
    personType?: string;
    jobNum: string;
    name?: string;
    phone: string;
  }
  export interface SavePersonForm {
    cid: string | number;
    personType: string;
    jobNum: string;
    name: string;
    phone: string;
    photoPath: string;
    code: string;
  }
  // export interface studentResObj {
  //   companyId: number;
  //   companyName: string;
  //   userId: number;
  //   personId: number;
  //   jobNum: string;
  //   name: string;
  //   phone: string;
  //   deptName: string;
  //   cardNo: string;
  //   photoPath: string;
  //   amount: number;
  // }
  export interface SwitchForm {
    companyId: string | number;
    personId: string | number;
  }
}

// 用户登录
export const login = (params: Login.LoginReqForm) => {
  // 返回的数据格式可以和服务端约定
  return axios.post<Login.LoginResData>(Api.ALogin, params);
};

// 获取验证码
export const sendCode = (params: Login.SendCodeForm) => {
  // return axios.post(Api.code, params);
  return axios.http({
    url: Api.code,
    headers: {
      isToken: false,
    },
    method: "post",
    data: params,
  });
};

// 保存
export const savePerson = (params: Login.SavePersonForm) => {
  // return axios.post(Api.updatePerson, params);
  return axios.http({
    url: Api.updatePerson,
    headers: {
      isToken: false,
    },
    method: "post",
    data: params,
  });
};

// 获取微信绑定学生列表
export const getStudent = () => {
  return axios.get(Api.queryStudent);
};

// 切换微信绑定当前学生
export const switchBind = (params: Login.SwitchForm) => {
  return axios.post(Api.switchBind, params);
};
